@if (showToggle) {
  <div class="tt-drawer_toggle-button">
    <button (click)="toggleButtonClicked.emit()">
      <mat-icon
        class="tt-drawer_toggle-button-icon"
        [class.tt-drawer_toggle-button-icon--opened]="opened"
        [icon]="'chevron-right'"
        [iconSize]="14" />
    </button>
  </div>
}

<ng-content />
